import { MdmObject } from "gql/generated/types";
import React from "react";

type ObjectAnalyticsProps = {
  object: MdmObject
}

const ObjectAnalytics: React.FC<ObjectAnalyticsProps> = ({ object }) => {
  
  return (
    <div>
      {object.title}
    </div>
  )
}

export default ObjectAnalytics;